import { render, staticRenderFns } from "./TabPlaylist.vue?vue&type=template&id=82a23ade&scoped=true"
import script from "./TabPlaylist.vue?vue&type=script&lang=js"
export * from "./TabPlaylist.vue?vue&type=script&lang=js"
import style0 from "./TabPlaylist.vue?vue&type=style&index=0&id=82a23ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a23ade",
  null
  
)

export default component.exports